<ng-content></ng-content>
<input type="checkbox" class="__checkbox">
<span class="__checkmark"></span>
